export const defaultConnections = ['AemEnvironment', 'WkoManager', 'TranslationManager', 'Tracking'];
export const defaultPackages = ['ComponentRegistry', 'DealerContext', 'WkoManager'];
export const defaultStarters = ['SeamlessStore', 'SeamlessLogger'];
